export default {
    namespaced: true,
    state: {
        navMenuMarkets: {
            title: 'markets',
            icon: 'mdi-soccer',
            subItems: [
                {
                    title: 'favourite',
                    breadcrumb: 'breadcrumb_favourite',
                    icon: 'mdi-star',
                    iconColor: 'yellow darken-3',
                    link: 'favourite',
                },
                { title: 'orders' },
                {
                    title: 'live',
                    breadcrumb: 'breadcrumb_live',
                    link: 'feedLive',
                },
                {
                    title: 'pregame',
                    breadcrumb: 'breadcrumb_pregame',
                    link: 'feedDball',
                    divider: true,
                },
                { title: 'bots' },
                {
                    title: 'botLiveFeed',
                    breadcrumb: 'breadcrumb_botLiveFeed',
                    link: 'feedLiveBot',
                },
                {
                    title: 'botPregame',
                    breadcrumb: 'breadcrumb_botPregame',
                    link: 'feedDballBot',
                },
            ],
        },
        navMenuTrading: {
            title: 'trading',
            icon: 'mdi-list-box-outline',
            subItems: [
                { title: 'bets', link: 'bet' },
                { title: 'orders', link: 'order' },
                { title: 'errorLog', link: 'betFail' },
            ],
        },
        navMenuTools: {
            title: 'tools',
            icon: 'mdi-tools',
            subItems: [
                { title: 'botManagement', link: 'bot' },
                { title: 'leagueGroups', link: 'leagueGroup' },
                { title: 'leagues', link: 'league' },
                { title: 'teams', link: 'team' },
            ],
        },
        navMenuMarketsWL: {
            title: 'markets',
            icon: 'mdi-soccer',
            subItems: [
                { title: 'orders' },
                {
                    title: 'live',
                    breadcrumb: 'breadcrumb_live',
                    link: 'feedLive',
                },
                {
                    title: 'pregame',
                    breadcrumb: 'breadcrumb_pregame',
                    link: 'feedDball',
                    divider: true,
                },
                { title: 'bots' },
                {
                    title: 'botLiveFeed',
                    breadcrumb: 'breadcrumb_botLiveFeed',
                    link: 'feedLiveBot',
                },
                {
                    title: 'botPregame',
                    breadcrumb: 'breadcrumb_botPregame',
                    link: 'feedDballBot',
                },
            ],
        },
        navMenuToolsWL: {
            title: 'tools',
            icon: 'mdi-tools',
            subItems: [
                { title: 'leagueGroups', link: 'leagueGroup' },
                { title: 'leagues', link: 'league' },
                { title: 'teams', link: 'team' },
            ],
        },
        navMenuGuestMarkets: {
            title: 'markets',
            icon: 'mdi-soccer',
            subItems: [
                { title: 'orders' },
                {
                    title: 'live',
                    breadcrumb: 'breadcrumb_live',
                    link: 'feedLive',
                },
                {
                    title: 'pregame',
                    breadcrumb: 'breadcrumb_pregame',
                    link: 'feedDball',
                },
            ],
        },

        navMenuSupportItems: [
            {
                title: 'terms',
                link: 'terms',
            },
            {
                title: 'guide',
                link: 'guide',
            },
        ],
        navMenuWLSupportItems: [
            {
                title: 'terms',
                link: 'terms',
            },
            {
                title: 'guide',
                link: 'guide',
            },
        ],
        breadcrumbs: [],
        languages: [
            {
                id: 1,
                value: 'en',
            },
            {
                id: 2,
                value: 'pt',
            },
        ],
        withMenu: true,
        userMenu: false,
        notificationMenu: false,
        notificationBadge: false,
        mobileMenuDrawer: false,
        menuDate: false,
        menuDateFrom: false,
        menuDateTo: false,

        selection: [],
    },
    mutations: {
        setSelection(state, selection) {
            state.selection = selection;
        },
        setWithMenu(state, withMenu) {
            state.withMenu = withMenu;
        },
        setBreadcrumbs(state, breadcrumbs) {
            for (let key in breadcrumbs) {
                breadcrumbs[key]['text'] = this.$i18n.t('menu.' + breadcrumbs[key]['text']);
            }

            state.breadcrumbs = breadcrumbs;
        },
        setUserMenu(state, userMenu) {
            state.userMenu = userMenu;
        },
        setNotificationBadge(state, notification) {
            state.notificationBadge = notification && notification.length > 0;
        },
        setNotificationMenu(state, notificationMenu) {
            state.notificationMenu = notificationMenu;
        },
        setMobileMenuDrawer(state, mobileMenuDrawer) {
            state.mobileMenuDrawer = mobileMenuDrawer;
        },
        setMenuDateFrom(state, menuDateFrom) {
            state.menuDateFrom = menuDateFrom;
        },
        setMenuDate(state, menuDate) {
            state.menuDate = menuDate;
        },
        setMenuDateTo(state, menuDateTo) {
            state.menuDateTo = menuDateTo;
        },
        setLanguages(state, languages) {
            state.languages = languages;
        },
    },
    getters: {
        getSelection(state) {
            return state.selection;
        },
        getWithMenu(state) {
            return state.withMenu;
        },
        getNavMenuItems(state) {
            return [state.navMenuMarkets, { title: 'bots', link: 'bot' }, state.navMenuTrading, state.navMenuToolsWL];
        },
        getNavMenuItemsWL(state) {
            return [
                state.navMenuMarketsWL,
                { title: 'bots', link: 'bot' },
                state.navMenuTrading,
                state.navMenuToolsWL,
                {
                    title: 'favourite',
                    link: 'favourite',
                    icon: 'mdi-star',
                    iconColor: 'yellow darken-3',
                },
            ];
        },
        getNavMenuGuestItems(state) {
            return [state.navMenuGuestMarkets];
        },
        getBreadcrumbs(state) {
            return state.breadcrumbs;
        },
        getNavMenuSupportItems(state) {
            return state.navMenuSupportItems;
        },
        getNavMenuWLSupportItems(state) {
            return state.navMenuWLSupportItems;
        },
        getUserMenu(state) {
            return state.userMenu;
        },
        getNotificationMenu(state) {
            return state.notificationMenu;
        },
        getNotificationBadge(state) {
            return state.notificationBadge;
        },
        getMobileMenuDrawer(state) {
            return state.mobileMenuDrawer;
        },
        getMenuDateFrom(state) {
            return state.menuDateFrom;
        },
        getMenuDate(state) {
            return state.menuDate;
        },
        getMenuDateTo(state) {
            return state.menuDateTo;
        },
        getLanguages(state) {
            return state.languages;
        },
    },
    actions: {},
};
